import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn,
  FaYoutube
} from 'react-icons/fa';
import { HiEnvelope, HiPhone, HiHome, HiInformationCircle } from 'react-icons/hi2';
import { SUPPORT_CONTACT } from '../common/utils';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300 border-t border-gray-700">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-1">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-orange-400 to-yellow-400 bg-clip-text text-transparent mb-4">
              Utsav Buy
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Your trusted shopping partner. Quality products, great deals, and exceptional service.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-blue-600 flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF className="text-sm" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-sky-500 flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                aria-label="Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter className="text-sm" />
              </a>
              <a
                href="https://www.instagram.com/utsav_buy?igsh=M29mdWN0b2NnbTRk"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-pink-600 flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="text-sm" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-blue-700 flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn className="text-sm" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-red-600 flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110"
                aria-label="YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube className="text-sm" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h4 className="text-white font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 flex items-center gap-2 text-sm">
                  <HiHome className="text-xs" />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 flex items-center gap-2 text-sm">
                  <HiInformationCircle className="text-xs" />
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 flex items-center gap-2 text-sm">
                  <HiPhone className="text-xs" />
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/order" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  My Orders
                </Link>
              </li>
              <li>
                <Link to="/wallet" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Wallet
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className="col-span-1">
            <h4 className="text-white font-semibold text-lg mb-4">Customer Service</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/help-center" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/shipping-info" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/returns-refunds" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Returns & Refunds
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-span-1">
            <h4 className="text-white font-semibold text-lg mb-4">Get in Touch</h4>
            <ul className="space-y-3">
              {/* <li className="flex items-start gap-3">
                <HiEnvelope className="text-orange-400 mt-1 flex-shrink-0" />
                <a href="mailto:support@utsavbuy.com" className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  support@utsavbuy.com
                </a>
              </li> */}
              <li className="flex items-start gap-3">
                <HiPhone className="text-orange-400 mt-1 flex-shrink-0" />
                <a href={`tel:${SUPPORT_CONTACT.phone}`} className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm">
                  {SUPPORT_CONTACT.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              &copy; {currentYear} Utsav Buy. All Rights Reserved.
            </p>
            <p className="text-gray-500 text-xs text-center md:text-right">
              Made with ❤️ for our customers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
